import React, { useEffect, useState } from "react";
import Modal from "../UI/Modal";
import Button from "../UI/Button";
import LoadingSpinner from "../UI/LoadingSpinner";
import * as aiService from "../../services/aiService";
import { toast } from "react-toastify";

export default function AISuggestionModal({
  isOpen,
  onClose,
  sectionType = "summary",
  promptContext = {},
  onSelect,
}) {
  const [loading, setLoading] = useState(false);
  const [suggestions, setSuggestions] = useState([]);
  const [editing, setEditing] = useState("");

  useEffect(() => {
    setSuggestions([]);
    setEditing("");
  }, [isOpen]);

  async function generate() {
    try {
      setLoading(true);
      let jobTitle = "";
      let description = "";

      if (sectionType === "summary") {
        jobTitle = (promptContext.jobTitle || "").trim();
        description = (promptContext.currentDescription || "").trim();
      } else {
        jobTitle = (promptContext.position || "").trim();
        description = (promptContext.currentDescription || "").trim();
      }

      // Validate inputs
      if (!jobTitle) {
        toast.error("Job title/position is required");
        setLoading(false);
        return;
      }
      if (!description) {
        toast.error("Current description is required");
        setLoading(false);
        return;
      }

      const res = await aiService.suggestContent(jobTitle, description);
      let result = Array.isArray(res?.suggestions) ? res.suggestions : res;
      setSuggestions(result || []);
      if ((result || []).length) setEditing(result[0]);
    } catch (e) {
      toast.error(
        e?.response?.data?.message || "Failed to generate suggestions"
      );
    } finally {
      setLoading(false);
    }
  }

  function handleApply() {
    if (!editing.trim()) {
      toast.error("Please select or edit a suggestion first");
      return;
    }
    onSelect?.(editing.trim());
    onClose?.();
  }

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="AI Suggestions" size="lg">
      <p className="text-sm text-gray-600 mb-3">Costs 1 credit per use.</p>
      <div className="mb-3">
        <Button onClick={generate} disabled={loading}>
          Generate Suggestions
        </Button>
      </div>
      {loading ? (
        <LoadingSpinner />
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
          <div className="space-y-2">
            {!suggestions.length ? (
              <p className="text-sm text-gray-500">
                No suggestions yet. Click Generate.
              </p>
            ) : (
              suggestions.map((s, idx) => (
                <button
                  key={idx}
                  type="button"
                  onClick={() =>
                    setEditing(Array.isArray(s) ? s.join("\n") : s)
                  }
                  className="w-full text-left border rounded p-2 hover:bg-gray-50"
                >
                  {Array.isArray(s) ? s.join("\n") : s}
                </button>
              ))
            )}
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Selected/Edited
            </label>
            <textarea
              className="w-full h-48 rounded border border-gray-300 px-3 py-2"
              value={editing}
              onChange={(e) => setEditing(e.target.value)}
            />
            <div className="mt-3 flex justify-end gap-2">
              <Button variant="ghost" onClick={onClose}>
                Cancel
              </Button>
              <Button onClick={handleApply}>Apply</Button>
            </div>
          </div>
        </div>
      )}
    </Modal>
  );
}
